import { Stack } from "@mui/material";
import SignUpForm from "../Signup/components/SignUpForm";
import { useCallback, useEffect, useState } from "react";
import { useIsMobile } from "src/hooks/useIsMobile";
import { useNavigate } from "react-router-dom";

import { Paths } from "src/constants/paths";
import AllRightsReserved from "src/components/AllRightsReserved";

const Login = () => {
  const [productSlug, setProductSlug] = useState("st");
  const isMobile = useIsMobile();

  const navigate = useNavigate();

  const onSuccess = useCallback(async () => {
    navigate(Paths.AUTH_QUEUE);
  }, [navigate]);

  useEffect(() => {
    if (isMobile) {
      document.documentElement.classList.add("signup-page");

      return () => {
        document.documentElement.classList.remove("signup-page");
      };
    }
  }, [isMobile]);

  useEffect(() => {
    let slug = localStorage.getItem("product") ?? "st";

    if (["ec", "on"].includes(slug)) {
      slug = "st";
    }

    setProductSlug(slug);
  }, [productSlug]);

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      height="100%"
      padding="1rem"
    >
      <SignUpForm
        isSignUp={false}
        onSuccess={onSuccess}
        productSlug={productSlug}
      />
      <AllRightsReserved />
    </Stack>
  );
};

export default Login;
